<template>
	<div>
		<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
			<div class="modal-dialog modal-sm" role="document">
				<div class="modal-content">
					<div class="modal-header">
						<div class="btn-toolbar pull-right" role="toolbar">
							<div class="btn-group" role="group" aria-label="...">
								<button type="button" class="close" data-dismiss="modal" aria-label="Close">
									<span aria-hidden="true">&times;</span>
								</button>
							</div>
						</div>
						<h4 class="modal-title">Tipo de documento</h4>
					</div>
					<div class="list-group m-b-0">
						<button @click="addTask()" type="button" class="list-group-item">
							<i aria-hidden="true" class="fa ti ti-flag-alt fa-fw"></i>
							Tarea
							<i class="fa fa-plus pull-right" aria-hidden="true"></i>
						</button>
					</div>
					<div class="modal-footer">
						<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
					</div>
				</div>
			</div>
		</div>

		<create-project
			@reload="reload"
			@createTask="openTaskCreate"
			ref="createProject"
			:user="user"
			:isAuth="isAuth">
		</create-project>

		<task-create
			ref="taskCreate"
			@openCreateSchedule="openCreateSchedule"
			@reload="reload"
			:project="item"
			:user="user"
			:isAuth="isAuth">
		</task-create>

		<schedule-create
			ref="schedulecreate"
			@reload="reload"
			:user="user"
			:isAuth="isAuth">
		</schedule-create>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	import CreateProject from '@/components/projects/projects/views/Create.vue'
	import TaskCreate from '@/components/projects/tasks/views/Create.vue'
	import ScheduleCreate from '@/components/projects/schedules/views/Create.vue'

	export default {
		props: ['user', 'isAuth', 'item'],
		components: {
			'create-project': CreateProject,
			'task-create': TaskCreate,
			'schedule-create': ScheduleCreate,
		},
		data () {
			return {
				modal: {
					selector: 'modal-add-resource-customer'
				},
			}
		},
		methods: {
			open() {
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			reload() {
				this.$emit('reload')
			},
			addTask() {
				this.close()
				this.$refs.taskCreate.open(this.item)
			},
			openCreateSchedule(item) {
				this.$refs.schedulecreate.item = item
				this.$refs.schedulecreate.open()
			},
			openTaskCreate(data) {
				this.$refs.taskCreate.open(data)
			},
			openCreate() {
				this.$refs.createProject.open()
			}
		}
	};
</script>


// WEBPACK FOOTER //
// src/components/projects/projects/views/Add.vue